import React, { useState, useEffect } from "react";
import { AnchorLink as Link } from "gatsby-plugin-anchor-links";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem("cookieConsent");

    if (!cookieConsent) {
      // Show popup after a small delay for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());

    // Add smooth closing animation
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
    }, 300);

    // Optional: Trigger any analytics or tracking code here
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "granted",
      });
    }
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());

    // Add smooth closing animation
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
    }, 300);

    // Optional: Update analytics consent
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "denied",
      });
    }
  };

  const handleClose = () => {
    // Just close without storing preference (will show again on next visit)
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className={`cookie-backdrop ${
          isClosing ? "cookie-backdrop-closing" : ""
        }`}
        onClick={handleClose}
      />

      {/* Cookie Consent Popup */}
      <div
        className={`cookie-consent-popup ${
          isClosing ? "cookie-popup-closing" : ""
        }`}>
        <div className="cookie-content">
          <div className="cookie-header">
            <h4>🍪 We Value Your Privacy</h4>
            <button
              className="cookie-close-btn"
              onClick={handleClose}
              aria-label="Close cookie consent">
              ×
            </button>
          </div>

          <div className="cookie-body">
            <p>
              We use cookies and similar technologies to enhance your browsing
              experience, analyze site traffic, and personalize content. By
              clicking "Accept All", you consent to our use of cookies.
            </p>

            <div className="cookie-links">
              <Link to="/privacy-policy" className="cookie-policy-link">
                Privacy Policy
              </Link>
              <span className="cookie-separator">|</span>
              <Link to="/toc" className="cookie-policy-link">
                Terms & Conditions
              </Link>
            </div>
          </div>

          <div className="cookie-actions">
            <button
              className="cookie-btn cookie-btn-reject"
              onClick={handleReject}>
              Reject All
            </button>
            <button
              className="cookie-btn cookie-btn-accept"
              onClick={handleAccept}>
              Accept All
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
